import { useState } from 'react';

import api from 'api';

import { useGetCFLink } from './useGetCFLink';

import { decagonClient } from '@/services/decagonClient';

export const useHandleContactRequest = () => {
    const link = useGetCFLink();
    const [isLoading, setIsLoading] = useState(false);

    const openFallbackLink = () => window.open(link, '_blank');

    const onClick = async () => {
        setIsLoading(true);
        try {
            if (decagonClient.isNotInitialised) {
                const { token: handoffToken } = await api.user.getTokenHandoff();
                await decagonClient.initialise({ handoffToken });
            }

            await decagonClient.open();
        } catch {
            openFallbackLink();
        } finally {
            setIsLoading(false);
        }
    };

    return { isLoading, onClick };
};
